export const pusherConfig = (request:any) => {
  let params:any = {}
  const listPusherConfig:any = {
    'iknow-chat': {
      appKey: process.env.REACT_APP_PUSHER_APP_KEY_CHAT || '',
      channelName: process.env.REACT_APP_PUSHER_CHAT || '',
      eventName: process.env.REACT_APP_PUSHER_EVENT_CHAT || '',
      cluster: process.env.REACT_APP_CLUSTER_CHAT || '',
      enabledTransports: ["ws", "wss"],
    },
    'lms': {
      appKey: process.env.REACT_APP_PUSHER_APP_KEY_LMS || '',
      channelName: process.env.REACT_APP_PUSHER_CHANNEL_LMS || '',
      eventName: process.env.REACT_APP_PUSHER_EVENT_LMS || '',
      cluster: process.env.REACT_APP_CLUSTER_LMS || '',
      enabledTransports: ["ws", "wss"],
    }
  }
  if (listPusherConfig.hasOwnProperty(request)) { params = listPusherConfig[request] }
  return params
};
